module.exports = __webpack_public_path__ + "img/icon-16-refresh.ce1949fc.svg";